import { useField } from 'formik'
import { ChangeEvent, FocusEvent, Ref, useCallback } from 'react'
import { Input as AntdInput, InputRef as AntdInputRef } from '../../Input'
import { InputProps as AntdInputProps } from '../../Input'
import { FormikFieldProps } from '../typings/FieldProps'

export type InputProps = FormikFieldProps &
  AntdInputProps & {
    ref?: Ref<AntdInputRef>
  }

export const Input = ({
  name,
  onChange: onChangeProp,
  onBlur: onBlurProp,
  value: _valueProp,
  ...restProps
}: InputProps) => {
  const [field] = useField(name)
  const { value, onChange, onBlur } = field

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event)
      onChangeProp?.(event)
    },
    [onChange, onChangeProp]
  )

  const handleBlur = useCallback(
    (event: FocusEvent<HTMLInputElement>) => {
      onBlur(event)
      onBlurProp?.(event)
    },
    [onBlur, onBlurProp]
  )

  return (
    <AntdInput
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      {...restProps}
    />
  )
}
